import { Button, Grid, Typography } from "@material-ui/core";
import CustomDateField from "components/CustomDateField";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  List,
  TextField,
  SearchInput,
  FunctionField,
  ReferenceField,
  ListProps,
  SelectInput,
} from "react-admin";
import { Helmet } from "react-helmet";
import { GridinRow, GridLabel } from "utils/style";
import { SchoolIdSelected } from "utils/tools";
import { isMaxLevelList, isNotHaveRoutesList, statusList } from "./const";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import React from "react";
import InternalNoteStudentButton from "./components/InternalNoteStudentButton";
import BusDataListField from "./components/BusDataListField";

const StudentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
    <SelectInput
      label="Is Have Routes"
      source="IsNotHaveRoutes"
      choices={isNotHaveRoutesList}
      alwaysOn
    />
    <SelectInput
      label="Is Max Level"
      source="IsMaxLevel"
      choices={isMaxLevelList}
      alwaysOn
    />
  </Filter>
);

const StudentList = (props: ListProps) => {
  const StudentShowButton = (record: IStudent) => {
    return (
      <Button href={`/#/students/${record.id}/show`}>
        <VisibilityIcon />
      </Button>
    );
  };

  const StudentEditButton = (record: IStudent) => (
    <Button href={`/#/students/${record.id}`}>
      <EditIcon />
    </Button>
  );

  return (
    <>
      <Helmet>
        <title>Students</title>
      </Helmet>
      <List
        exporter={false}
        filters={<StudentFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
        hasCreate={false}
      >
        <Datagrid>
          <FunctionField
            label="Student Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>

                  <TextField source="id" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>

                  <FunctionField
                    render={(record: any) =>
                      `${record.firstName} ${record.lastName}`
                    }
                    emptyText="-"
                  />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Gender :
                  </Typography>

                  <TextField source="gender" emptyText="-" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    School :
                  </Typography>
                  <ReferenceField
                    source="schoolId"
                    reference="schools"
                    link={false}
                    emptyText="-"
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Level :
                  </Typography>
                  <ReferenceField
                    source="levelId"
                    reference="levels"
                    link={false}
                    emptyText="-"
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Class :
                  </Typography>
                  <ReferenceField
                    source="levelGroupId"
                    reference="levelGroups"
                    link={false}
                    emptyText="-"
                  >
                    <TextField source="name" />
                  </ReferenceField>
                </Grid>
              </SanitizedGrid>
            )}
          />
          <FunctionField
            label="Parent Info"
            render={() => (
              <SanitizedGrid container spacing={2}>
                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Id :
                  </Typography>
                  <TextField source="parent.id" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Name :
                  </Typography>
                  <FunctionField
                    render={(record: any) =>
                      `${record.parent?.firstName} ${record.parent?.lastName}`
                    }
                  />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Email :
                  </Typography>
                  <TextField source="parent.email" />
                </Grid>

                <Grid item xs={12} style={GridinRow}>
                  <Typography variant="body2" style={GridLabel}>
                    Mobile :
                  </Typography>
                  <TextField source="parent.mobile" />
                </Grid>
              </SanitizedGrid>
            )}
          />
          <CustomDateField
            source="createdAt"
            label="Created On"
            emptyText="-"
            isDateTime
          />
          <FunctionField
            label="Bus Data"
            render={(props: any) => <BusDataListField studentId={props.id} />}
          />
          <StatusField source="status" />
          <FunctionField
            label="Actions"
            render={(props: any) => (
              <>
                <StudentShowButton {...props} />
                <StudentEditButton {...props} />
                <InternalNoteStudentButton studentId={props.id} />
              </>
            )}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default StudentList;
